export default __webpack_public_path__ + "static/media/bf9a030a1ec3f875.e363a3ff6189e1a9af16857c08506646.svg";